import { useParams } from 'react-router';

import { ProductSubscriptionRenewPageParamsType } from '../../models/types/RoutePath';
import ProductViewContent from '../../styledComponents/ProductViewContent/ProductViewContent';
import {
  RenewSubscriptionPages,
  RenewSubscriptionViewsPermissions,
} from './subscriptionRenewPage.utils';

const SubscriptionRenewPage = () => {
  const { productType } = useParams<ProductSubscriptionRenewPageParamsType>();
  return (
    <ProductViewContent
      productType={productType}
      viewsPages={RenewSubscriptionPages}
      viewsPermissions={RenewSubscriptionViewsPermissions}
    />
  );
};

export default SubscriptionRenewPage;
